import { TechnicalDataValues } from '@org-avp/avp-hck-dga-customerui-commons';
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  Text,
} from '@volkswagen-onehub/components-core';

export type TechnicalDataTableProps = {
  category: string;
  values: TechnicalDataValues[];
};

export const TechnicalInformationTable = (props: TechnicalDataTableProps): JSX.Element | null => {
  if (!props.values || !props.values.length) {
    return null;
  }

  return (
    <>
      <Table tableHeight="auto">
        <TableBody>
          {props.values.map(({ description, value }) => (
            <TableRow key={props.category.concat('-').concat(description)}>
              <TableHeader emphasized>
                <Text bold>{description}</Text>
              </TableHeader>
              <TableCell>{value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
